var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 12.5003H3.33341C2.89139 12.5003 2.46746 12.3247 2.1549 12.0122C1.84234 11.6996 1.66675 11.2757 1.66675 10.8337V3.33366C1.66675 2.89163 1.84234 2.46771 2.1549 2.15515C2.46746 1.84259 2.89139 1.66699 3.33341 1.66699H10.8334C11.2754 1.66699 11.6994 1.84259 12.0119 2.15515C12.3245 2.46771 12.5001 2.89163 12.5001 3.33366V4.16699M9.16675 7.50033H16.6667C17.5872 7.50033 18.3334 8.24652 18.3334 9.16699V16.667C18.3334 17.5875 17.5872 18.3337 16.6667 18.3337H9.16675C8.24627 18.3337 7.50008 17.5875 7.50008 16.667V9.16699C7.50008 8.24652 8.24627 7.50033 9.16675 7.50033Z",
    stroke: "#FFCF00",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCodeIcon);
export default __webpack_public_path__ + "static/media/copyCodeIcon.384b5fc3ce248ec596668b62300d02e1.svg";
export { ForwardRef as ReactComponent };